import './error.css';

export const Error = () => {
  return (
    <div id="error">
      <div className="error-emoji">😔</div>
    </div>
  );
};
